import React from 'react';
import { Link } from 'react-router-dom';
import { Settings } from '../configuration/settings';

function Breadcrumbs(props: { items: {text: string, url?: string, title?: string }[]}) {
  const breadcrumbs = [
    { text: "Чоловічі джинси Levi’s", url: "/" },
    ...props.items
  ];

  return (<>
    <nav className="mt-2" style={{ marginBottom: "-.3rem" }} aria-label="breadcrumb">
      <ol className="breadcrumb breadcrumb-one-line">
      {breadcrumbs.map((breadcrumb, index) => 
          breadcrumb.url
          ? <li className="breadcrumb-item">
              <Link className="link-secondary" to={breadcrumb.url} title={breadcrumb.title ?? breadcrumb.text}>{breadcrumb.text}</Link>
            </li>
          : <li className="breadcrumb-item active" aria-current="page">{breadcrumb.text}</li>
      )}
      </ol>
    </nav>
    <script type="application/ld+json">{`
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [${breadcrumbs.map((breadcrumb, index) =>
        `
        {
          "@type": "ListItem",
          "position": ${index + 1},
          "name": "${breadcrumb.title ?? breadcrumb.text}"${breadcrumb.url ? "," : ""}${breadcrumb.url ? `
          "item": "${Settings.siteUrl}${breadcrumb.url}"` : ""}
        }`)}
      ]
    }`} 
    </script>
  </>);
}

export default Breadcrumbs;
